import React from 'react';
import { Box, Typography, Button, List, ListItem, ListItemIcon, ListItemText, Grid } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import tradersRoomImage from "backgroundImages/TradersRoom.png";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

function TradersRoomBox() {

  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));

  const handleNavigation = (option, path) => {
    localStorage.setItem("page", option);
    window.location.href = path;
  };



  return (
    <Box
      style={{
        backgroundColor: "#dadada",
        padding: "1rem",
        borderRadius: "1rem",
        background: "rgba(218, 218, 218, 0.6)",
        border: "0.1rem solid #dadada",
        backdropFilter: "blur(3px)",

      }}
    >
      <Grid
        container
        style={{
          backgroundColor: "#ffffff",
          padding: "3rem  1rem 3rem 1rem",
          borderRadius: "1rem",
          border: "0.1rem solid #dadada",
          justifyContent: "space-around",
          display: "flex",
          alignContent: "center",

        }}
      >
      <Grid
          item
          lg={4}
          sm={12}
          display={"inline"}
          justifyContent={"center"}
          textAlign={smDown ? "center" : "left"}
          padding={"1rem"}
        >
          <Typography
            gutterBottom
            style={{ color: "#000", fontWeight: "600", fontSize: "1rem", marginBottom: "1rem" }}
          >
            Traders Room
          </Typography>

          <Typography
            variant="body1"
            color="rgb(176, 184, 196)"
            fontSize={"0.8rem"}
            paragraph
          >
            Why Juggle Multiple Tools?<br />
            With ChartingHQ’s Traders' Room, everything you need—from market analysis to order placement—is right here on one screen. Stay focused, stay informed, and take control of your trades with ease.
          </Typography>

          <List>
            <ListItem >
              <CheckBoxIcon style={{ color: "#8E69FD", height: "1rem", marginRight: "0.5rem" }} />
              <Typography
                variant="body1"
                color="#000"
                fontSize={"0.8rem"}

                paragraph
              >
                Comprehensive Market View: Monitor candle charts for BANKNIFTY, NIFTY, and FINNIFTY, along with real-time Call and Put data, all on a single screen.
              </Typography>

              <ListItemText primary="" />
            </ListItem>

            <ListItem>
              <CheckBoxIcon style={{ color: "#8E69FD", height: "1rem", marginRight: "0.5rem" }} />
              <Typography
                variant="body1"
                color="#000"
                fontSize={"0.8rem"}

                paragraph
              >
                OI Insights at Your Fingertips: Track the top 6 strikes with the highest Open Interest (OI) through clear line charts, helping you spot key market trends instantly.
              </Typography>
            </ListItem>


            <ListItem>
              <CheckBoxIcon style={{ color: "#8E69FD", height: "1rem", marginRight: "0.5rem" }} />
              <Typography
                variant="body1"
                color="#000"
                fontSize={"0.8rem"}
                paragraph
              >
                Combined Strike Analysis: Seamlessly compare selected Call and Put strikes with a combined chart, allowing for deeper analysis without switching screens.
              </Typography>
            </ListItem>


          </List>

          <Button
            variant="contained"
            style={{ color: "#fff", backgroundColor: "#000", fontSize: "0.8rem" }}
            mt={2}
            onClick={() => handleNavigation("oc", "/OptionChain")}
          >
            Access Option Chain
          </Button>

        </Grid>

        {/* <Grid
          item
          lg={5}
          sm={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            textAlign: "center",
            alignItems: "center",
          }}
        >
          <Box>
            {!smDown ? (
              <img
                src={tradersRoomImage}
                alt="ChartingHQ logo"
                style={{ height: "20rem" }}
              />
            ) : (
              <></>
            )}
          </Box>

        </Grid> */}


<Grid
          item
          lg={8}
          sm={12}
          display={"inline"}
          justifyContent={"center"}
          textAlign={smDown ? "center" : "left"}
    
        >
              <Box sx={{display:"flex", justifyContent:"center", marginBottom:"2rem", marginTop:"2rem", }}>
            {!smDown ? (
              <img
                src={tradersRoomImage}
                alt="ChartingHQ logo"
                style={{ height: "50vh", width: "50vw", border:"2px solid #000", borderRadius:"1rem"}}
              />
            ) : (
              <></>
            )}
          </Box>
          </Grid>

      </Grid>
    </Box>
  );
}

export default TradersRoomBox;
